/**
* 路由
*/
import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入各模块
import routesIndex from '$routes/modules/index'
import routesAbout from '$routes/modules/about'
import routesInfo from '$routes/modules/info'
import routeAgr from '$routes/modules/agr'

// import store from '$stores'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: routesIndex.concat(routesAbout, routesInfo, routeAgr)
})

router.beforeEach((to, from, next) => {
  next()
})

/**
 * 路由进入后
 * 1、关闭loading
 * 2、更新页面title
 * 3、随手记【返回】按钮控制
 * 4、container class设置
 */
router.afterEach((to) => {
  window.scrollTo(0, 0)
  if (to.meta.title) {
    // 更新页面title
    // clientTitle.set(to.meta.title)
    document.getElementsByTagName('title')[0].text = to.meta.title
  }
  // 更换container class
  // const { containerClass = '' } = to.meta
  // store.commit('common_container_class', containerClass)
})

/**
 * HACK:暂时封装一个toast方法
 */

export default router



// WEBPACK FOOTER //
// ./src/routes/index.js